/* eslint-disable react/forbid-component-props */
import React from 'react'
import { Box, Typography, Link } from '@mui/material'

const ListItem = ({ children }) => (
  <Box sx={{ display: 'flex', flexDirection: 'row', mb: 1 }}>
    <Box sx={{ height: '100%', mr: 1 }}>
      <Typography>{'\u2022' + ' '}</Typography>
    </Box>
    <Typography>{children}</Typography>
  </Box>
)

const DogLawUK = () => (
  <Box>

    <Typography variant="h5" mb={3} id="dog-law">
      7. UK Dog Law
    </Typography>
    <Typography mb={3}>
      We all know that owning a dog is a big responsibility. A dog/handler
      relationship can be immensely rewarding, provided it has been built with
      love, care and respect.
    </Typography>
    <Typography mb={3}>
      All dog owners in the UK have a legal duty to make sure they are providing
      for their pup’s welfare needs.
    </Typography>
    <Typography mb={3}>
      It’s important to be aware of your obligations when taking on the
      responsibility of an animal, but with so many different acts, legislations
      and codes of conduct in place, staying up-to-date with specific laws can
      get confusing. The laws cited here are as of 2022. We shall endeavour to
      update this chapter when any changes in the law occurs but as a dog
      owner/handler it is your responsibility to keep up to date with UK dog
      law. Should you be interested, Cooper & Co Solicitors provide a variety of
      Dog Law webinars that can be attended from the comfort of your own home.
    </Typography>
    <Link href="https://doglaw.co.uk/seminars/doglaw-seminars/" target="_blank" rel="noopener noreferrer">
      https://doglaw.co.uk/seminars/doglaw-seminars/
    </Link>
    <Typography mb={3} fontWeight="bold" id="duty-of-care">
      An owner&apos;s duty of care
    </Typography>
    <Typography mb={3}>
      The Animal Welfare Act 2006 was set up to ensure pet owners meet the five
      welfare needs when looking after their animals.{' '}
    </Typography>
    <Typography mb={3}>
      Under this act, if a dog’s needs aren’t met, dog owners could be
      prosecuted for animal cruelty.
    </Typography>
    <Typography mb={3}>
      The term ‘cruelty’, refers to the act of causing an animal unnecessary
      suffering.
    </Typography>
    <Typography mb={3}>
      As well as covering deliberate infliction of pain or hurt onto an animal,
      cruelty includes neglect and failing to meet a dog’s needs to live a
      healthy and fulfilled life.
    </Typography>
    <Typography mb={3}>
      In the UK, all domestic animals, including dogs, have the legal right to:
    </Typography>
    <ListItem>
      <Typography component="span" fontWeight="bold">Environment</Typography>: Live in a suitable
      environment.
    </ListItem>
    <ListItem>
      <Typography component="span" fontWeight="bold">Diet</Typography>: Eat a suitable diet.
    </ListItem>
    <ListItem>
      <Typography component="span" fontWeight="bold">Behaviour</Typography>: Exhibit normal behaviour
      patterns.
    </ListItem>
    <ListItem>
      <Typography component="span" fontWeight="bold">Companionship</Typography>: Be housed with, or
      apart from, other animals.
    </ListItem>
    <ListItem>
      <Typography component="span" fontWeight="bold">Health</Typography>: Be protected from pain,
      suffering, injury and disease.{' '}
    </ListItem>
    <Typography mb={3}>
      <Typography component="span" fontWeight="bold">Top Tip</Typography>: The Code of Practice for the
      Welfare of Dogs provides more information to help pet owners understand
      and meet these five needs.
    </Typography>
    <Typography mb={3}>
      <Typography component="span" fontWeight="bold">
        Under section 32 of the Animal Welfare Act 2006
      </Typography>
      , dog owners who are found to be failing to care for their dogs could
      face:
    </Typography>
    <ListItem>
      Going to court and facing a prison sentence of up to 51 weeks{' '}
    </ListItem>
    <ListItem>A fine of up to £20,000</ListItem>
    <ListItem>Their dog being taken away</ListItem>
    <ListItem>Being banned from owning pets in the future</ListItem>
    <Typography mb={3} fontWeight="bold" id="finns-law">
      Finn&apos;s Law
    </Typography>
    <Typography mb={3}>
      In 2019, legislation was introduced under the Animal Welfare Act to make
      it harder for people who harm Assistance Animals to claim that they were
      doing so in self defence.
    </Typography>
    <Typography mb={3}>
      Referred to as ‘Finn’s Law’, this amendment followed the stabbing of a
      police dog named Finn.
    </Typography>
    <Typography mb={3}>
      Finn sadly sustained stab wounds to the chest and his head, but at the
      time, the only charges brought against his attacker were criminal damage.
    </Typography>
    <Typography mb={3}>
      As of June 2021, Finn’s Law Part 2 has brought a change in the law which
      has{' '}
      <Typography component="span" fontWeight="bold">
        increased the maximum prison sentence for such animal cruelty from six
        months to five years
      </Typography>{' '}
      with an unlimited fine.
    </Typography>
    <Box component="img" src="https://firebasestorage.googleapis.com/v0/b/pads-foundation.appspot.com/o/site-assets%2Fimage%20(86).jpg?alt=media" alt="" sx={{ display: "block", mx: "auto", my: 2, maxWidth: "100%", width: "300px" }} />
    <Typography mb={3} sx={{ textDecoration: "underline", fontSize: 18 }} id="dogs-road">
      Laws on driving with dogs and road accidents{' '}
    </Typography>
    <Typography mb={3} fontWeight="bold" id="highway-code">
      The Highway Code
    </Typography>
    <Typography mb={3}>
      Under the Highway Code, published in 2015 and updated in March 2022,
      certain rules regarding driving with dogs and walking with dogs are in
      place.
    </Typography>
    <Typography mb={3}>Dog owners should be aware of.</Typography>
    <ListItem>
      <Typography component="span" fontWeight="bold">Rule 56</Typography>: Do not let a dog out on the
      road on its own. Keep it on a short lead when walking on the pavement,
      road or path shared with cyclists or horse riders.
    </ListItem>
    <ListItem>
      <Typography component="span" fontWeight="bold">Rule 57</Typography>: When in a vehicle, make sure
      dogs or other animals are suitably restrained so they cannot distract you
      while you are driving or injure you, or themselves, if you stop quickly. A
      seat belt harness, pet carrier, dog cage or dog guard are ways of
      restraining animals in cars.
    </ListItem>
    <Typography mb={3}>
      Breaking the Highway Code is not currently an offence in the UK. However,
      the act of allowing a dog to distract or injure you while driving could be
      taken into account in the event of an accident.
    </Typography>
    <Typography mb={3} fontWeight="bold" id="traffic-act">
      Road Traffic Act
    </Typography>
    <Typography mb={3}>
      <Typography component="span" fontWeight="bold">
        Section 170 of the Road Traffic Act 1988
      </Typography>{' '}
      states that any driver who injures a dog while driving a car, motorbike or
      other vehicle type must
      <Typography component="span" fontWeight="bold">
        provide their name and address to the dog owner
      </Typography>{' '}
      or person in charge of the dog at the time.
    </Typography>
    <Typography mb={3}>
      In the event that no person is accompanying the dog during the time of the
      accident, drivers are required to{' '}
      <Typography component="span" fontWeight="bold">report the incident to the police</Typography>
      within 24 hours.
    </Typography>
    <Typography mb={3}>
      Under this act, failure to stop or report is an offence and could result
      in the following:{' '}
    </Typography>
    <ListItem>
      <Typography component="span" fontWeight="bold">Penalty points</Typography> on your driving
      licence from 5 - 10
    </ListItem>
    <ListItem>
      <Typography component="span" fontWeight="bold">A fine</Typography> of up to £5,000
    </ListItem>
    <Typography mb={3} sx={{ textDecoration: "underline", fontSize: 18 }} id="dogs-public">
      Laws on walking with your dog in public places{' '}
    </Typography>
    <Typography mb={3} fontWeight="bold" id="pspo">
      Public Spaces Protection Orders (PSPOs)
    </Typography>
    <Typography mb={3}>
      Previously referred to as Dog Control Orders (DCOs), Public Spaces
      Protection Orders are in place in certain public areas in England and
      Wales.
    </Typography>
    <Typography mb={3}>
      It’s important to{' '}
      <Typography component="span" fontWeight="bold">
        refer to the PSPOs that exist in your local area
      </Typography>
      .
    </Typography>
    <Typography mb={3}>
      Each local council is required to provide public access to these rules via
      their website.
    </Typography>
    <Typography mb={3}>
      While each specific PSPO can differ from place to place, the orders may
      require dog owners to:
    </Typography>
    <ListItem>
      Clear up after their dogs (keeping pick up bags on hand during dog walks)
    </ListItem>
    <ListItem>
      Limit the number of dogs being walked at one time (regardless of personal
      or professional dog walking status){' '}
    </ListItem>
    <ListItem>
      Keep dogs on leads, and follow instructions to put dogs on leads if told
      to by police officers, support officers or council members{' '}
    </ListItem>
    <ListItem>
      Prevent dogs from entering specific places like parks, children’s play
      areas and farmlands
    </ListItem>
    <Typography mb={3}>
      Under these regulations, dog owners found to be breaking orders can be
      fined. These fines include:{' '}
    </Typography>
    <ListItem>
      <Typography component="span" fontWeight="bold">Fixed Penalty Notice</Typography>: Fined £100 on
      the spot
    </ListItem>
    <ListItem>
      <Typography component="span" fontWeight="bold">A higher fine</Typography> up to £1,000 if the
      charge goes to court
    </ListItem>
    <Typography mb={3} fontWeight="bold" id="traffic-act">
      Road Traffic Act
    </Typography>
    <Typography mb={3}>
      <Typography component="span" fontWeight="bold">Section 27</Typography> of this act outlines the
      <Typography component="span" fontWeight="bold">rules for walking dogs on roads</Typography>.
    </Typography>
    <Typography mb={3}>
      Under this act, a person who is found to be{' '}
      <Typography component="span" fontWeight="bold">
        walking their dog without a lead on a designated road could be guilty of
        an offence.
      </Typography>
    </Typography>
    <Typography mb={3}>
      A ‘designated road’ in this context means a length of road specified by an
      order on behalf of the local authority in whose area the length of road is
      situated.
    </Typography>
    <Typography mb={3}>
      For this reason, it’s important to check the roads in your local area, as
      local councils have the power to issue specific PSPOs as mentioned.
    </Typography>
    <Typography mb={3} fontWeight="bold" id="country-code">
      The Countryside Code
    </Typography>
    <Typography mb={3}>
      This code outlines advice for enjoying UK parks, waterways, coastal and
      countryside areas safely.
    </Typography>
    <Typography mb={3}>
      When it comes to walking your dog in these areas, it’s important to{' '}
      <Typography component="span" fontWeight="bold">keep your dog under control</Typography> to ensure
      it stays away from wildlife, livestock, horses and other people.
    </Typography>
    <Typography mb={3}>To do so, the code advises: </Typography>
    <ListItem>Keeping a dog on lead or in sight</ListItem>
    <ListItem>Being confident in a dog’s recall abilities</ListItem>
    <ListItem>
      Making sure a dog doesn’t stray from the path or area where right of
      access applies
    </ListItem>
    <Typography mb={3}>
      As per the PSPOs mentioned above, it’s crucial to check local signage
      provided by the council to ensure you are following local restrictions.
    </Typography>
    <Typography mb={3} fontWeight="bold" id="livestock">
      Livestock Protection
    </Typography>
    <Typography mb={3}>
      The code highlights the importance of keeping a dog on a lead when walking
      close to livestock.{' '}
    </Typography>
    <Typography mb={3}>
      It is a legal requirement to keep your dog on a lead when walking on Open
      Access land(even if there is no livestock on the land at the time of your
      walk).
    </Typography>
    <Typography mb={3}>
      The most crucial piece of information here is that under section 9 of the
      Animals Act 1971 and Protection of Livestock Act 1953, ‘a farmer can shoot
      a dog that is attacking or chasing livestock. They may not be liable to
      compensate the dog’s owner.’{' '}
    </Typography>
    <Typography mb={3}>
      Find out more about{' '}
      <Link href="https://www.gov.uk/government/publications/the-countryside-code/the-countryside-code-advice-for-countryside-visitors" target="_blank" rel="noopener noreferrer">
        The Countryside Code.
      </Link>
    </Typography>
    <Typography component="span" fontWeight="bold">A summary of UK dog walking laws: </Typography>
    <ListItem>
      <Typography component="span" fontWeight="bold">Dog Fouling</Typography>: Not cleaning up after
      your dog can result in an on-the-spot fine up to £100 depending on your
      local council’s PSPO.
    </ListItem>
    <ListItem>
      <Typography component="span" fontWeight="bold">Carrying Pick-up Bags</Typography>: Some councils
      have made it mandatory to carry a poop scoop and disposable bag when
      walking dogs in public places.{' '}
    </ListItem>
    <ListItem>
      <Typography component="span" fontWeight="bold">Walking On Agricultural Land</Typography>: Under
      certain circumstances, farmers retain the right to stop and / or shoot
      dogs that are chasing or attacking their livestock.
    </ListItem>
    <ListItem>
      <Typography component="span" fontWeight="bold">Walking On Designated Roads</Typography>: It is a
      criminal offence for dogs to be walked on these roads without being held
      on a lead.{' '}
    </ListItem>
    <Box component="img" src="https://firebasestorage.googleapis.com/v0/b/pads-foundation.appspot.com/o/site-assets%2Fimage%20(87).jpg?alt=media" alt="" sx={{ display: "block", mx: "auto", my: 2, maxWidth: "100%", width: "400px" }} />
    <Typography mb={3} sx={{ textDecoration: "underline", fontSize: 18 }} id="dogs-others">
      Laws on keeping others safe around your dog
    </Typography>
    <Typography mb={3}>
      It is a legal requirement to keep your dog under control in both private
      and public places, and failure to do so could result in you being fined,
      sent to prison for up to six months, or both.
    </Typography>
    <Typography mb={3}>
      It is against the law to allow your dog to be dangerously out of control
      and injure, or threaten to injure another person or animal. It is a
      criminal offence if your dog makes someone{' '}
      <Typography component="span" fontWeight="bold">reasonably fear injury</Typography>. If this can
      be proven beyond a reasonable doubt the dog will be considered to have
      been dangerously out of control under{' '}
      <Typography component="span" fontWeight="bold">
        Section 3 of the Dangerous Dogs Act 1991.
      </Typography>
    </Typography>
    <Typography mb={3}>
      The DDA recognises the potential every dog has of displaying dangerous
      behaviour and makes a provision for it in section 3.
    </Typography>
    <Typography mb={3}>
      It is an offence if a dog (of any breed or type):
    </Typography>
    <ListItem>Is dangerously out of control in a public place</ListItem>
    <ListItem>Is dangerously out of control in a private place</ListItem>
    <ListItem>
      Is dangerously out of control in a private place where he is not allowed
      to be
    </ListItem>
    <Typography mb={3}>A dog is dangerously out of control if:</Typography>
    <ListItem>Dog injures a person</ListItem>
    <ListItem>
      Dog behaves in such a way that makes a person worry that he may injure
      them
    </ListItem>
    <Typography mb={3}>
      Both the dog’s owner and the person in charge of the dog at the time are
      liable.
    </Typography>
    <Typography mb={3}>
      If a dog is owned or under the care of a person under 16, the head of the
      household is deemed responsible if the dog is dangerously out of control.
    </Typography>
    <Typography mb={3}>
      Section 3 of the Act applies to every single dog owner in England and
      Wales. Under this section, it is a criminal offence for the person in
      charge of the dog to allow it to be ‘dangerously out of control’ in a
      public place.
    </Typography>
    <Typography mb={3}>
      A dog does <Typography component="span" fontWeight="bold">not</Typography> have to bite to be
      deemed dangerous in the eyes of the law.
    </Typography>
    <Typography mb={3}>
      Generally, if a dog bites a person, he will be presumed to have been
      ‘dangerously out of control’.
    </Typography>
    <Typography mb={3}>
      However, even if the dog does not bite, but gives the person grounds to
      <Typography component="span" fontWeight="bold">feel</Typography> that the dog may injure them,
      the law still applies.
    </Typography>
    <Typography mb={3}>Some dog owners remain unaware of this.</Typography>
    <Typography mb={3}>
      The penalties in place for this law include:
    </Typography>
    <ListItem>
      <Typography component="span" fontWeight="bold">Up to five years imprisonment</Typography> and /
      or a fine if you fail to stop your dog from injuring someone
    </ListItem>
    <ListItem>
      <Typography component="span" fontWeight="bold">A ‘malicious wounding’ charge</Typography> if you
      deliberately use your dog to injure someone
    </ListItem>
    <ListItem>
      <Typography component="span" fontWeight="bold">Up to fifteen years imprisonment</Typography> and
      / or an unlimited fine if you allow your dog to kill someone{' '}
    </ListItem>
    <ListItem>
      <Typography component="span" fontWeight="bold">Up to three years imprisonment</Typography> and or
      a fine if you don’t prevent your dog from injuring an Assistance Dog{' '}
    </ListItem>
    <Typography mb={3}>
      The DDA was originally introduced to outlaw attacks on people and was
      rushed through with no thought to other potential victims. A number of
      groups have been campaigning over the years to change the law in order to
      protect assistance dogs and their owners. The number of attacks on
      assistance dogs by other dogs has steadily increased. Between March 2011
      and February 2013 there were 240 attacks on Guide Dogs alone. When an
      assistance dog is attacked by another dog it is traumatic (and sometimes
      fatal) for the dog, but also traumatic for the client too. Assistance dogs
      rarely respond when they are attacked as they have been deliberately
      chosen for their temperament. Attacks can lead to the withdrawal of the
      dog from the service, further impacting the client’s mental and physical
      capacity, as well as their safety and security. Additionally, the
      financial cost of training an assistance dog often means that those whose
      dogs are retired face a long wait for another dog, thus further limiting
      their ability to live independently.
    </Typography>
    <Typography mb={3}>
      The role of an “assistance dog” is now part of the DDA. The meaning of
      this is specified by section 173(1) of the Equality Act 2010:
    </Typography>
    <ListItem>a dog which has been trained to guide a blind person</ListItem>
    <ListItem>a dog which has been trained to assist a deaf person</ListItem>
    <ListItem>
      a dog which has been trained by a prescribed charity to assist a disabled
      person who has a disability that consists of epilepsy or otherwise affects
      the person’s mobility, manual dexterity, physical co ordination or ability
      to lift, carry or otherwise move everyday objects
    </ListItem>
    <ListItem>
      a dog of a prescribed category which has been trained to assist a disabled
      person who has a disability (other than one falling within category c) of
      a prescribed kind.
    </ListItem>
    <Typography mb={3}>
      The DDA has been extended so that section 3 applies to assistance dogs.
      Where it discusses the risk of injuring a person it has been extended.
      This means that a dog will be dangerously out of control where there are
      grounds for reasonable apprehension that it will injure any assistance
      dog,{' '}
      <Typography component="span" fontWeight="bold">whether or not it actually does so</Typography>.
    </Typography>
    <Typography mb={3}>
      Previously, an offence under the DDA was restricted to an injury to any
      person. This has now been amended to include “or assistance dog”.
      <Typography component="span" fontWeight="bold">
        Therefore, neither a person nor an assistance dog needs to be the victim
        of an actual bite for an offence to be committed
      </Typography>
      . Growling, snarling or even bared teeth resulting in no injury to a
      person or dog still means an offence has been committed. If the assistance
      dog is actually injured it then becomes an{' '}
      <Typography component="span" fontWeight="bold">aggravated offence</Typography>. The owner of the
      dangerously out of control dog faces a maximum sentence of 3 years
      imprisonment and the dog could be euthanized under a court order.
    </Typography>
    <Typography mb={3}>
      The British Veterinary Association (BVA) and the RSPCA, along with others
      campaigned to change the law to protect all dogs that were victims of
      attack by another dog, but the amendment did not include all dogs.
    </Typography>
    <Typography mb={3}>
      In May 2014, The Scottish Parliament introduced a measure which is
      equivalent to the Anti-Social Behaviour, Crime and Policing Act. The
      Control of Dogs (Scotland) Act was already in place which empowered dog
      wardens to be able to issue Dog Control Notices to try and curb
      anti-social behaviour from dogs. The impact of these laws is currently
      being monitored.
    </Typography>
    <Box component="img" src="https://firebasestorage.googleapis.com/v0/b/pads-foundation.appspot.com/o/site-assets%2Fimage%20(88).jpg?alt=media" alt="" sx={{ display: "block", mx: "auto", my: 2, maxWidth: "100%", width: "350px" }} />
    <Typography mb={3} sx={{ textDecoration: "underline", fontSize: 18 }} id="stray">
      Laws on stray dogs, breeding and buying puppies{' '}
    </Typography>
    <Typography mb={3}>
      There are several acts and legislation in place to protect dogs and
      puppies when it comes to breeding, buying and selling canines.{' '}
    </Typography>
    <Typography mb={3}>
      In England and Wales, it is{' '}
      <Typography component="span" fontWeight="bold">
        illegal to sell a puppy under the age of eight weeks old.
      </Typography>{' '}
    </Typography>
    <Typography mb={3} fontWeight="bold">Lucy’s Law</Typography>
    <Typography mb={3}>
      Following a petition against poor puppy farming conditions, Lucy’s Law
      came into effect in April 2020.{' '}
    </Typography>
    <Typography mb={3}>
      Lucy was a Cavalier King Charles Spaniel rescued from a Welsh puppy farm,
      where she had been found to spend five years in a cage, used to
      continuously breed litters upon litters of puppies.
    </Typography>
    <Typography mb={3}>
      Under Lucy&apos;s Law, it is{' '}
      <Typography component="span" fontWeight="bold">
        illegal to sell puppies and kittens under the age of six months old
        unless the seller has bred the puppy or kitten themselves
      </Typography>
      , or is a legitimate rescue centre.
    </Typography>
    <Typography mb={3} fontWeight="bold">Environmental Protection Act 1990 </Typography>
    <Typography mb={3}>
      Under this act, any person who finds a stray dog has an obligation to make
      an attempt to:
    </Typography>
    <ListItem>Reunite them with their owner </ListItem>
    <ListItem>Report them to a dog warden </ListItem>
    <Typography mb={3}>
      In England and Wales, the police are not responsible for stray dogs.{' '}
    </Typography>
    <Typography mb={3}>
      However, if you find a stray dog and do not contact a dog warden, you
      could be accused of theft.{' '}
    </Typography>
    <Box component="img" src="https://firebasestorage.googleapis.com/v0/b/pads-foundation.appspot.com/o/site-assets%2Fimage%20(89).jpg?alt=media" alt="" sx={{ display: "block", mx: "auto", my: 2, maxWidth: "100%", width: "350px" }} />
    <Typography mb={3} sx={{ textDecoration: "underline", fontSize: 18 }} id="microchip">
      Microchipping and dog tags, UK law
    </Typography>
    <Typography component="span" fontWeight="bold">
      It is a legal requirement for dogs in England to be microchipped, and for
      their details to be registered on an authorised database.
    </Typography>
    <Typography mb={3}>
      Dog owners must also ensure that the information provided on the database
      is kept up-to-date.{' '}
    </Typography>
    <Typography mb={3}>
      Under the new microchipping laws - which have been in place since 6 April
      2016 - dog owners found by police not to have microchipped their dogs will
      be given a short period to comply.{' '}
    </Typography>
    <Typography mb={3}>
      After this period, a fine of up to £500 could be issued.
    </Typography>
    <Typography mb={3} fontWeight="bold">The Control of Dogs Order 1992</Typography>
    <Typography mb={3}>
      In addition to microchipping, there are also rules when it comes to the
      use of collars and dog tags.
    </Typography>
    <Typography component="span" fontWeight="bold">
      UK law requires pups to wear dog collars with identification tags in
      public places.
    </Typography>
    <Typography mb={3}>These dog tags must display: </Typography>
    <ListItem>The name of the dog owner (initials and surname)</ListItem>
    <ListItem>
      An up-to-date address of the owner (house number and postcode)
    </ListItem>
    <Typography mb={3}>
      Despite not being a legal requirement, it is also a good idea to include
      your phone number on the tag too.
    </Typography>
    <Typography mb={3} sx={{ textDecoration: "underline", fontSize: 18 }} id="access-rights">Public Access Rights</Typography>
    <Typography mb={3} fontWeight="bold">Equality Act 2010</Typography>
    <Link href="http://www.legislation.gov.uk/ukpga/2010/15" target="_blank" rel="noopener noreferrer">
      http://www.legislation.gov.uk/ukpga/2010/15
    </Link>
    <Typography mb={3}>
      It is against the law for service providers to treat people with
      disabilities less favourably because of their disability, or because they
      have a guide or assistance dog with them.
    </Typography>
    <Typography mb={3}>
      Making “reasonable adjustments” might mean giving extra help, such as
      guiding someone to a restaurant table, or making some changes to the way
      you provide your services to make it easier for those with assistance dogs
      to use them. It certainly includes allowing guide dogs and assistance dogs
      into all public places with their owners.
    </Typography>
    <Typography mb={3}>
      Guide dog and assistance dog owners have important rights under the
      Equality Act 2010. The EA provides for disabled people to have the same
      right to services supplied by shops, banks, hotels, libraries, pubs, taxis
      and restaurants as everyone else.
    </Typography>
    <Typography mb={3}>
      According to ADI the definition of an Assistance Dog is as follows:
    </Typography>
    <Typography mb={3}>
      A generic term for a guide, hearing or service dog specifically trained to
      do more than one task to mitigate an individual’s disabilities. The
      presence of a dog for protection, personal defence, or comfort does not
      qualify that dog as an assistance dog.
    </Typography>
    <Typography mb={3}>
      Please visit https://pads.foundation/paws-for-access/ for more
      information.
    </Typography>

    
  </Box>
)

export default DogLawUK
